/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotOrgMetrics {
    getFixupPrototypeFunction() { return CopilotOrgMetrics.fixupPrototype; }

    static newInstance(model: Partial<CopilotOrgMetrics>): CopilotOrgMetrics {
        let obj = Object.assign(new CopilotOrgMetrics(), model);
        CopilotOrgMetrics.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotOrgMetrics>): CopilotOrgMetrics {
        if (!model) return null;
        return CopilotOrgMetrics.newInstance(<CopilotOrgMetrics> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotOrgMetrics) {
        if (!obj) return;

        models.CopilotOrgMetrics.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotOrgMetrics): boolean {
        Object.setPrototypeOf(obj, CopilotOrgMetrics.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.active_seats === undefined) {
            this.active_seats = 0;
        }
        if (this.total_seats === undefined) {
            this.total_seats = 0;
        }
    }

    /**
     * Number of active Copilot seats
     */
    active_seats: number;

    /**
     * Total number of Copilot seats
     */
    total_seats: number;

}
